/* eslint-disable import/no-cycle */
/* eslint-disable class-methods-use-this */
import { BaseModel } from '@/_models/base'

export class Organization extends BaseModel {
  constructor(id = null, name = null) {
    super()

    this.id = id
    this.name = name
  }

  static modelName = 'organization'

  static modelNamePlural = 'organizations'

  fromJSON(json) {
    return Object.assign(new Organization(), json)
  }
}

export const cOrganization = new Organization()
